import { helper } from '@ember/component/helper';

import { toArray } from 'rise-ui/utils/array.js';

export default helper(function groupedItemsWithResultHelper([ groupedItems ]) {
  return toArray(groupedItems).filter(groupedItem =>
    groupedItem.items.some(item => item.temporalStartDate)
  );
});
